import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';
import * as F from '../../lib/util/CommonFunctions';
import BrBrandHomeItem from '../../components/br/BrBrandHomeItem'
import ProdItemSlider from '../../components/common/prod/ProdItemSlider';

const HpBrandItemBlock = styled.div`

    margin-top: ${isMobileOnly?"40px":"60px"};

    .rb-info {
        position: relative;
        
        ${isMobileOnly?"width: 172px;":"width: 266px;height: 212px"};
        //height: 212px;
        line-height: 1.4;
        ${!isMobileOnly && "padding-right: 30px"};
        font-size: 14px;
        ${isMobileOnly && "min-width:172px;"}; /* JP for responsive */
        ${isMobileOnly && "margin-right: 4vw"};
        /* JP for responsive */
        .rb-desc {
          text-overflow: ellipsis;
          overflow: hidden;
          //${isMobileOnly && "font-size: 0.9em"};
          ${isMobileOnly && "font-size: 13px; color: #999999;"};
        }
        /* JP for responsive */
    }
    .rb-info-container {
        ${isMobileOnly?`
        display: flex;
        width:96vw;
        overflow: hidden;
        `:`
        display: flex;/* JP for responsive */
        justify-content: space-between;        
        `}

    }
    .rb-logo {
        height: 28px;
        margin-bottom: 12px;
    }

    .rb-tag_list {
        margin-top: 10px;
        margin-left: -5px;
        //white-space: nowrap;
        //text-overflow:ellipsis;
        overflow: hidden;
        height: 70px;
    }

    .rb-tag_list .dotted-tag {
        margin-left: 5px;
        margin-top: 10px;
        ${isMobileOnly && "font-size: 0.7em"}; 
    }

    .rb-list li {
        ${isMobileOnly && "padding-left: 0px"}; 
        ${isMobileOnly && "padding-right: 30px"}; 
    }
`;

const HpBrandBoxBlock = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    //height: 40px;
    height: ${isMobileOnly?"36px":"40px"};
    overflow: hidden;
    display:flex;   
/*JPKIM*/
    //::after {
    //    content: "";
    //    display: block;
    //    clear: both;
    //}
/*JPKIM*/
    .rb-fc-btn {
    /*JP*/        
        ${!isMobileOnly&&"float: left"};
        width: ${isMobileOnly?"125px":"186px"};
        height: ${isMobileOnly?"36px":"40px"};
        ${!isMobileOnly&&"padding: 11px 10px 10px;margin-right: 10px;"};
        font-size: ${isMobileOnly&&'0.8em'};
        ${isMobileOnly&&"display:flex; align-items:center;justify-content:center;margin-right:10px;"};
        /*JP*/                
        color: #fff;
        background-color: #111;
        text-align: center;
        
        
    }

    .rb-fc-btn .new {
        color: #79b88a;
        font-weight: 700;
    }

    .bookmark-btn {
        //float: left;
        ${isMobileOnly&&"height:36px;width:36px;"};
    }

    .no_po {
        position: static;
    }

    .rb-fc-btn::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 11px;
        margin-left: 10px;
        background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const HpBrandItemPBlock = styled.p`
    margin-bottom: 20px;    
    min-height: 150px;
    cursor: pointer;
    line-height : 151px;
`;

const HpBrandListItemImg = styled.img`
    border-radius: 4px;
    min-width: 100%; 
    min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    max-height: 152px;
    max-width : 152px;
    vertical-align : middle;
    object-fit: cover;
`;

const SearchBrandAndPdListMBlock = styled.div`
    .mobile-pd-conatiner {
        overflow: scroll;
        overflow-y: hidden;
        display: flex;
        padding: 0 0 10px 0;
        //width: max-content;

        .pd-slider:last-child {
            padding-right: 4vw;
        }
        .pd-slider:first-child {
            margin-left: 4vw;
        }
    }
`;

const HpBrandItem = ({ brandinfo, reqClip, isClip }) => {

    return (
        isMobileOnly?
        <SearchBrandAndPdListMBlock className="clearfix mobile-brand">
            <BrBrandHomeItem img={brandinfo.brnd_thumb_url} brandInfo={brandinfo.brnd_info_brief}
                idHome={brandinfo.id} brInfo={brandinfo} brnd_han={brandinfo.brnd_han} reg_dtm={brandinfo.reg_dtm}/>
            
            <div style={{width:'100vw', marginLeft:'-4vw'}}>
                {
                    brandinfo.prods === null || brandinfo.prods === undefined ? '' :
                    <div className="mobile-pd-conatiner">
                        {
                        brandinfo.prods.map((curprod) => {
                            return (
                                <ProdItemSlider key={curprod._source.prdct_id}
                                    img={curprod._source.repr_img}
                                    prodname={curprod._source.prdct_nm}
                                    sale_price={curprod._source.sale_price}
                                    prdct_price={curprod._source.prdct_price}
                                    brandname={curprod._source.brnd_han}
                                    isBrandShow={false}
                                    brandid={curprod._source.brnd_id}
                                    prdct_id={curprod._source.prdct_id}
                                    prodinfo={curprod._source} />
                            )
                        })
                    }
                    </div>
                }
            </div>
        </SearchBrandAndPdListMBlock>
        :
        <HpBrandItemBlock>
            <li className="rb-info-container">
                <div className="rb-info">
                    <p className="rb-logo">
                        <img src={brandinfo.brnd_logo_url} alt="" />
                    </p>
                    <p className="rb-desc"> {brandinfo.brnd_info_brief}</p>
                    <ul className="rb-tag_list">
                        {
                            brandinfo.cate.map((curitem, index) => {
                                if (index < 5) {
                                    return <li className="dotted-tag" key={index}><span>{curitem.key}</span></li>
                                }
                            })
                        }
                    </ul>
                    <HpBrandBoxBlock className="font-mont">
                        <Link to={"/brHome/" + brandinfo.id}>
                            <div className="rb-fc-btn">

                                <span className="new">{brandinfo.new === 1 ? 'NEW ' : ''}
                                </span>BRAND HOME

                        </div>
                        </Link>
                        <button type="button"
                            className={isClip ? "bookmark-btn active" : "bookmark-btn"}
                            onClick={() => { reqClip(brandinfo.id) }}/>
                    </HpBrandBoxBlock>
                </div>
                <ul className="rb-list f-left" style={isMobileOnly?{}:{overflow:"hidden"}}>
                    {
                        brandinfo.prods === null || brandinfo.prods === undefined ? '' :
                            brandinfo.prods.map((curitem) => {
                                return (<li key={curitem._source.prdct_id}>
                                    <Link to={"/prod?prodid=" + curitem._source.prdct_id}>
                                        <HpBrandItemPBlock className="rb-list_img">
                                            <HpBrandListItemImg src={curitem._source.repr_img} alt="" />
                                        </HpBrandItemPBlock>
                                        <span className="product_title">{curitem._source.prdct_nm}</span>
                                        {/*<span className="product_pay">{Number(curitem._source.sale_price.toFixed(1)).toLocaleString()}</span>*/}
                                        {F.showAmount({
                                          prefix: "견적시작가 ",
                                          pfFontSize: "12px",
                                          pfWeight: "400",
                                          fontSize: "16px",
                                          amount: curitem._source.sale_price,
                                          weight: "500",
                                          unit:""
                                        })}
                                    </Link>
                                </li>)
                            })
                    }
                </ul>
            </li>


        </HpBrandItemBlock>
    );
};

export default HpBrandItem;
